import React, { Component } from 'react';

class Navigation extends Component {
  render() {
    return(
      <nav className="navbar navbar-expand-xl navbar-dark bg-dark">
        <a className="navbar-brand" href="https://softagram.com/">
          <img
            className="logo"
            src="https://softagram.com/wp-content/uploads/2017/02/Softagram_logo-white.png"
            alt="logo-img"
          />
        </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <a className="nav-link text-uppercase" href="https://softagram.com/">Homepage</a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-uppercase" href="https://softagram.com/open-source-showcases/">Showcase</a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-uppercase" href="https://softagram.com/blog/">Blog</a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-uppercase" href="https://softagram.com/company/">Company</a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-uppercase" href="https://softagram.com/careers/">Careers</a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-uppercase" href="https://softagram.com/products/">Product</a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-uppercase" href="https://softagram.com/#contact">Contact</a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-uppercase" href="https://private.softagram.com/">Login</a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
};

export default Navigation;